

import HttpService from "../Http/HttpService";
import { Store } from "../../app/store";
import { API_USER_DETAILS } from "./AuthenticationConstants";
import { clearAuth, setAuth } from "../../features/authSlice";
import { AUTH_STATUS_AUTHENTICATED } from "../../Constant";

export const bootstrapAuth = async (): Promise<void> => {
    try {
        const http = new HttpService();
        const response = await http.get(API_USER_DETAILS, {});
        Store.dispatch(
            setAuth({
                type: response.data.type,
                hasBusiness: response.data.hasBusiness,
                userId: response.data.userId ?? null,
                status : AUTH_STATUS_AUTHENTICATED
            })
        );
    } catch (error) {
        Store.dispatch(clearAuth());
    }
};
